import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-orientacoes-popup',
  templateUrl: './orientacoes-popup.component.html',
  styleUrls: ['./orientacoes-popup.component.css']
})
export class OrientacoesPopupComponent implements AfterViewInit {

  constructor(private cdr: ChangeDetectorRef) { }

  @ViewChild('popupContent') popupContent!: ElementRef<HTMLElement>;
  @Input() origem: string;
  @Input() isVisible;
  @Output() closed = new EventEmitter<void>();

  showButton = true;
  conteudoHtml;

  ngAfterViewInit(): void {
    const el = this.popupContent.nativeElement;
    el.focus();
    this.checkScroll();
    this.cdr.detectChanges();
  }

  onScroll(): void {
    this.checkScroll();
  }

  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    const keys = ['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Home', 'End'];
    if (keys.includes(event.code) && this.popupContent.nativeElement === document.activeElement) {
      setTimeout(() => this.checkScroll(), 0);
    }
  }

  private checkScroll() {
    const el = this.popupContent.nativeElement;
    const scrollTop = el.scrollTop;
    const maxScroll = el.scrollHeight - el.clientHeight;
    this.showButton = scrollTop >= maxScroll - 10 || this.isVisible;
  }

  closePopup(): void {
    this.isVisible = false;
    this.closed.emit();
  }
}
